import { makeVar } from '@apollo/client/cache/inmemory/reactiveVars'

interface WorkspaceProperty {
    articleIdToFocus?: string
    propertyToFocus?: string
    tabToFocus?: string
    propertyContentItemId?: string
    optionGroupToFocus?: string[]
    isAcceptAllRejectAll?: boolean
}

const initialWorkspaceProperty = {}

export const workspaceProperty = makeVar<WorkspaceProperty>(
    initialWorkspaceProperty
)

export const setIsAcceptAllRejectAll = (value: boolean) => {
    const currentWorkspaceElement = workspaceProperty()
    workspaceProperty({
        ...currentWorkspaceElement,
        isAcceptAllRejectAll: value,
    })
}
export const setArticleToFocus = (articleId: string | undefined) => {
    const currentWorkspaceElement = workspaceProperty()
    workspaceProperty({
        ...currentWorkspaceElement,
        articleIdToFocus: articleId,
    })
}

export const setPropertyToFocus = (
    elementId: string | undefined,
    contentItemId: string | undefined
) => {
    const currentWorkspaceElement = workspaceProperty()
    workspaceProperty({
        ...currentWorkspaceElement,
        propertyToFocus: elementId,
        propertyContentItemId: contentItemId,
    })
}
export const setOptionGroupToFocus = (options: string[] | undefined) => {
    const currentWorkspaceElement = workspaceProperty()
    workspaceProperty({
        ...currentWorkspaceElement,
        optionGroupToFocus: options,
    })
}

export const setTabToFocus = (partType: string | undefined) => {
    const currentWorkspaceElement = workspaceProperty()
    workspaceProperty({
        ...currentWorkspaceElement,
        tabToFocus: partType,
    })
}

export const resetOnFocusProperty = (isArticleIncluded?: boolean) => {
    workspaceProperty({
        tabToFocus: undefined,
        propertyToFocus: undefined,
        propertyContentItemId: undefined,
        articleIdToFocus: isArticleIncluded
            ? undefined
            : workspaceProperty().articleIdToFocus,
    })
}
